import { useCallback } from "react";
import { openWhatsAppChat, isWhatsAppAvailable } from "../services/whatsapp";

/**
 * Hook para manejo de WhatsApp
 * @returns {Object} Funciones de WhatsApp
 */
export const useWhatsApp = () => {
  /**
   * Abre chat de WhatsApp para un trámite específico
   */
  const openChat = useCallback((tramite, categoryName) => {
    if (!isWhatsAppAvailable()) {
      console.warn("WhatsApp no está configurado");
      return;
    }

    openWhatsAppChat(tramite, categoryName);
  }, []);

  /**
   * Verifica si WhatsApp está disponible
   */
  const isAvailable = useCallback(() => {
    return isWhatsAppAvailable();
  }, []);

  return {
    openChat,
    isAvailable,
  };
};
